Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-loyalty-contact-form');

    if ($form.length > 0) {
        InitContactForm($form);
    }

    function InitContactForm($formWrapper) {

        var $submitFormButton, formData, valOpts;

        var form = $formWrapper.get(0);

        form.bind = function () {

            formData = {
                "category": $("option:selected", 'select[name=category]').val(),
                "subject": $('input[name="subject"]').val(),
                "message": $('textarea[name="message"]').val()
            };

            valOpts = {
                subject: {
                    required: 'subject-required'
                },
                message: {
                    required: 'message-required'
                }
            };

            //add consent validations
            $.each($('div.consent.checkbox[data-required]', $form), function (e, el) {
                var consentType = $('input', el).attr('name');
                valOpts[consentType] = {
                    checkboxRequired: consentType + '-required'
                };
            });

            $formWrapper.validationEngine(valOpts);
            var rf = $formWrapper.data('validationEngine');

            $submitFormButton = $('.js-contact-submit-button', $formWrapper);

            $formWrapper.on('click', '.js-contact-submit-button', function (e) {
                valOpts = $formWrapper.validationEngine();

                $formWrapper.validationEngine(valOpts);
                var rf = $formWrapper.data('validationEngine');

                var valid = rf.validate();

                if (valid) {
                    if (LhApp.Context.IsConsentsEnabled) {
                        form.checkConsents();
                    } else {
                        form.submitForm();
                    }
                }
            });

            $formWrapper.on('keyup', 'input[name]', function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();

                    $submitFormButton.click();
                    return;
                };

                var $this = $(this);
                var fieldName = $this.attr('name');

                formData[fieldName] = $this.val();
                rf = $formWrapper.data('validationEngine');
                rf.validate(fieldName);
            });

            $formWrapper.on('keyup', 'textarea[name]', function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();

                    $submitFormButton.click();
                    return;
                };

                var $this = $(this);
                var fieldName = $this.attr('name');

                formData[fieldName] = $this.val();
                rf = $formWrapper.data('validationEngine');
                rf.validate(fieldName);
            });
        }

        form.checkConsents = function () {
            var data = [];

            var checkboxes = $('.form-row.consent.checkbox', form);
            $.each(checkboxes, function (e, el) {
                var chkbx = $('.checkbox-wrapper input', el);
                data.push({ type: chkbx.attr('id'), source: 'Loyalty Contact', approved: chkbx.prop("checked") });
            });

            if (data.length > 0) {
                window.ConsentsManager.insertConsents(data);
            } else {
                form.submitForm();
            }
        }

        form.submitForm = function () {
            form.loading(true);

            formData.category = $("option:selected", 'select[name=category]').val();
            formData.subject = omitScriptTag($('input[name="subject"]').val());
            formData.message = omitScriptTag($('textarea[name="message"]').val());

            Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.SubmitContactForm(formData));
        }

        form.onSuccess = function (envelope) {
            form.loading(false);

            var response = envelope.message.data;

            if (response.StatusCode === 200) {
                $('.js-error', $formWrapper).hide();
                $('.js-content', $formWrapper).hide();

                $('.js-success', $formWrapper).show();

            } else {
                $('.js-error', $formWrapper).show();
            };
        }

        form.onFailure = function (envelope) {
            form.loading(false);
            $('.js-error', $formWrapper).show();
        }

        form.loading = function (loading) {
            if (loading) {
                $formWrapper.addClass('x-loading');
            } else {
                $formWrapper.removeClass('x-loading');
            }
        }

        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SubmitContactFormSuccess, form, form.onSuccess);
        Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.SubmitContactFormFailure, form, form.onFailure);

        Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submitForm);

        form.bind();
    }

});